// src/pages/TenantManagement/TenantFilters.tsx
import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Label } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setFilters, clearFilters } from 'slices/tenantManagement/reducer';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('tenant_management');

interface TenantFiltersProps {
  onCreateTenant: () => void;
}

const TenantFilters: React.FC<TenantFiltersProps> = ({ onCreateTenant }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { filters } = useSelector((state: any) => state.TenantManagement);

  // Local state cho ô tìm kiếm — chỉ đẩy vào filters (kích hoạt gọi API) sau 500ms ngừng gõ
  const [searchValue, setSearchValue] = useState(filters.searchTerm || '');

  useEffect(() => {
    if (searchValue === filters.searchTerm) return;
    const timer = setTimeout(() => {
      dispatch(setFilters({ searchTerm: searchValue }));
    }, 500);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, dispatch]);

  useEffect(() => {
    if (filters.searchTerm === '') {
      setSearchValue('');
    }
  }, [filters.searchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

    const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    dispatch(setFilters({
      status: value === 'All' ? 'All' : parseInt(value) as 1 | 0
    }));
  };

  const handleClearFilters = () => {
    setSearchValue('');
    dispatch(clearFilters());
  };

        return (
        <Row className="mb-3 align-items-end">
          {/* Bên trái: Filters + Xóa bộ lọc */}
          <Col md="auto">
            <Label className="form-label mb-1">{st('tim_kiem_label')}</Label>
            <div className="search-box">
              <Input
                type="text"
                className="form-control"
                placeholder={st('nhap_ma_hoac_ten_don_vi_placeholder')}
                value={searchValue}
                onChange={handleSearchChange}
                style={{ width: '229px' }}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <Col md="auto">
            <Label className="form-label mb-1">{st('trang_thai_label_2')}</Label>
            <Input
              type="select"
              className="form-select"
              value={filters.status}
              onChange={handleStatusChange}
              style={{ width: '229px' }}
            >
              <option value="All">{st('tat_ca_option')}</option>
              <option value="1">{st('hoat_dong_option')}</option>
              <option value="0">{st('ngung_hoat_dong_option')}</option>
            </Input>
          </Col>
            <Col md="auto">
        <button
          type="button"
          className="btn btn-soft-secondary"
          onClick={handleClearFilters}
        >
          <i className="ri-refresh-line me-1"></i>
          {st('dat_lai_button')}
        </button>
      </Col>
      
      {/* Bên phải: Nút Thêm mới */}
      <Col md="auto" className="ms-auto">
        {PageActionPermission.canDisplay(location.pathname, "button-add") && (
        <button
          type="button"
          className="btn btn-primary"
          data-action-code="button-add"
          data-action-name="Thêm phòng ban/chi nhánh"
          onClick={onCreateTenant}
        >
          <i className="ri-add-line me-1"></i>
          {st('them_phong_ban_chi_nhanh_button')}
        </button>
        )}
      </Col>
    </Row>
  );
};

export default TenantFilters;